import { Expose, Transform, Type } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';

export class CurriculumManagerHistoryUserModel {
	uid: number;
	name: string;
}

export function CurriculumManagerHistoryUserModel_ClassTransform_Type() {
	return CurriculumManagerHistoryUserModel;
}

export class CurriculumManagerHistoryModel {
	@Expose({ name: 'performed_on_timestamp' })
	@Transform(dateTransformer)
	performed_on: Date;
	@Transform(dateTransformer)
	performed_on_date?: Date;
	action: string;
	@Type(CurriculumManagerHistoryUserModel_ClassTransform_Type)
	performed_by: CurriculumManagerHistoryUserModel;
	description: string;
}

export function CurriculumManagerHistoryModel_ClassTransform_Type() {
	return CurriculumManagerHistoryModel;
}

export class CurriculumManagerHistoryResponseModel {
	@Type(CurriculumManagerHistoryModel_ClassTransform_Type)
	results: CurriculumManagerHistoryModel[];
	count: number;
}
